import React from 'react';
import { HeroSectionV5 } from '../components/HeroSectionV5';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV5() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1205">
      <HeroSectionV5 data-id="element-1206" />
      <PainSection data-id="element-1207" />
      <TruthSection data-id="element-1208" />
      <ProductPresentation data-id="element-1209" />
      <ContentBreakdown data-id="element-1210" />
      <BenefitsSection data-id="element-1211" />
      <TestimonialsSection data-id="element-1212" />
      <ForYouSection data-id="element-1213" />
      <GuaranteeSection data-id="element-1214" />
      <BonusSection data-id="element-1215" />
      <ValueStack basePrice={12.99} popupStrikethroughPrice="$24.97 USD" popupSpecialPrice="$18.98 USD" showFlashBonus={false} data-id="element-1216" />
      <FAQSection data-id="element-1217" />
      <ImpactPhrases data-id="element-1218" />
      <Footer data-id="element-1219" />
    </div>;
}